var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-image"},[_c('img',{staticClass:"tw-w-full tw-h-full",attrs:{"src":_vm.computedSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }